import { render, staticRenderFns } from "./VerificationNotif.vue?vue&type=template&id=8f3d9b74&scoped=true"
import script from "./VerificationNotif.vue?vue&type=script&lang=js"
export * from "./VerificationNotif.vue?vue&type=script&lang=js"
import style0 from "./VerificationNotif.vue?vue&type=style&index=0&id=8f3d9b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3d9b74",
  null
  
)

export default component.exports